import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

const ROLE_OPTIONS = [
  
  { value: "EMPLOYEE", label: "Employee"},
  { value: "MANAGER", label: "Manager"},
  { value: "ADMIN_SUPPORT", label: "Admin Support"},
];

export const getUserFormFields = (
  isEditing = false,
  showPassword = false,
  togglePassword = () => {},
  isCurrentUserAdminSupport = false
) => {
  return [
    {
      name: "firstName",
      label: "First Name",
      type: "text",
      required: true,
      placeholder: "Enter first name",
      section: "User Details",
    },
    {
      name: "lastName",
      label: "Last Name",
      type: "text",
      required: true,
      placeholder: "Enter last name",
      section: "User Details",
    },
    {
      name: "userName",
      label: "Employee Id",
      type: "text",
      required: true,
      placeholder: "Enter employee number",
      section: "User Details",
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      required: true,
      placeholder: "Enter email",
      section: "User Details",
    },
    !isEditing && {
      name: "password",
      label: "Password",
      type: showPassword ? "text" : "password",
      required: true,
      placeholder: "Enter password",
      section: "User Details",
      suffix: showPassword ? (
        <EyeOutlined
          onClick={togglePassword}
          style={{ cursor: "pointer", color: "#8b8b8b" }}
        />
      ) : (
        <EyeInvisibleOutlined
          onClick={togglePassword}
          style={{ cursor: "pointer", color: "#8b8b8b" }}
        />
      ),
    },
    {
      name: "role",
      label: "Role",
      type: "select",
      required: isCurrentUserAdminSupport? false : true,
      placeholder: "Select a Role",
      options: ROLE_OPTIONS,
      section: "User Details",
      isDisabled: isCurrentUserAdminSupport,
    },
  ].filter(Boolean);
};